import React, { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import {
	CodigoPostal,
	InputError,
	InputGroupWrapper,
	InputWrapper,
	TextInputExtended,
} from 'src/components';
import { OneFormState } from 'src/types';

export const EmpresaComercialesInfoComponent = () => {
	const { register } = useFormContext();
	const { formInfo } = useSelector((state: OneFormState) => state);

	// Razon Social
	const [inputValueRazonSocial, setInputValueRazonSocial] = useState('');
	const [pristineRazonSocial, setPristineRazonSocial] = useState(true);
	const [errorRazonSocial, setErrorRazonSocial] = useState(false);
	const regExpOnlyRazonSocial = /[a-zA-Z]/gi;

	const handleChangeRazonSocial = (e: any) => {
		setInputValueRazonSocial(e.target.value);
		setPristineRazonSocial(false);
	};

	useEffect(() => {
		if (
			!pristineRazonSocial &&
			inputValueRazonSocial.match(regExpOnlyRazonSocial) === null
		) {
			setErrorRazonSocial(true);
		} else {
			setErrorRazonSocial(false);
		}
	}, [inputValueRazonSocial, pristineRazonSocial]);

	// CIF
	const [inputValueCIF, setInputValueCIF] = useState('');
	const [pristineCIF, setPristineCIF] = useState(true);
	const [errorCIF, setErrorCIF] = useState(false);
	const regExpCIF = /[A-Z]\d{8}/gi;

	const handleChangeCIF = (e: any) => {
		setInputValueCIF(e.target.value);
		setPristineCIF(false);
	};

	useEffect(() => {
		if (!pristineCIF && inputValueCIF.match(regExpCIF) === null) {
			setErrorCIF(true);
		} else {
			setErrorCIF(false);
		}
	}, [inputValueCIF, pristineCIF]);

	// Cargo en la empresa
	const [inputValueCargo, setInputValueCargo] = useState('');
	const [pristineCargo, setPristineCargo] = useState(true);
	const [errorCargo, setErrorCargo] = useState(false);
	const regExpCargo = /[a-zA-Z]/gi;

	const handleChangeCargo = (e: any) => {
		setInputValueCargo(e.target.value);
		setPristineCargo(false);
	};

	useEffect(() => {
		if (!pristineCargo && inputValueCargo.match(regExpCargo) === null) {
			setErrorCargo(true);
		} else {
			setErrorCargo(false);
		}
	}, [inputValueCargo, pristineCargo]);

	return (
		<>
			<InputGroupWrapper className="empresa_info-wrapper">
				<InputWrapper
					className="prefijo_telefono-input-wrapper"
					notALayer={formInfo.notALayer}
					paddingTop="0"
					paddingBottom="0"
				>
					<TextInputExtended
						name="razonSocial"
						label="Razón Social"
						isFloating
						innerRef={register({
							required: {
								value: true,
								message: 'Requerido',
							},
							pattern: {
								value: regExpOnlyRazonSocial,
								message: 'Solo se aceptan letras',
							},
						})}
						onChange={e => handleChangeRazonSocial(e)}
						required
					/>
					{errorRazonSocial && (
						<InputError className="input-error">
							Solo se aceptan letras
						</InputError>
					)}
				</InputWrapper>

				<InputWrapper
					className="prefijo_telefono-input-wrapper"
					notALayer={formInfo.notALayer}
					paddingTop="0"
					paddingBottom="0"
				>
					<TextInputExtended
						name="CIF"
						label="CIF"
						isFloating
						innerRef={register({
							required: {
								value: true,
								message: 'Requerido',
							},
							pattern: {
								value: regExpCIF,
								message: 'A00000000',
							},
						})}
						onChange={e => handleChangeCIF(e)}
						required
					/>
					{errorCIF && (
						<InputError className="input-error">
							Ejemplo: A00000000
						</InputError>
					)}
				</InputWrapper>

				<InputWrapper
					className="prefijo_telefono-input-wrapper"
					notALayer={formInfo.notALayer}
					paddingTop="0"
					paddingBottom="0"
				>
					<TextInputExtended
						name="cargo"
						label="Cargo"
						isFloating
						innerRef={register({
							required: {
								value: true,
								message: 'Requerido',
							},
							pattern: {
								value: regExpCargo,
								message: 'Solo se aceptan letras',
							},
						})}
						onChange={e => handleChangeCargo(e)}
						required
					/>
					{errorCargo && (
						<InputError className="input-error">
							Solo se aceptan letras
						</InputError>
					)}
				</InputWrapper>

				<CodigoPostal />
			</InputGroupWrapper>
		</>
	);
};
